import React, { useState } from "react";
import "./Experience.scss";

const EXPERIENCES = [
  {
    company: "Massive Rocket",
    companyUrl: "https://www.massiverocket.com/",
    location: "London, UK (Remote)",
    roles: [
      {
        title: "Developer",
        dateRange: "Sep 2024 – Present",
        bullets: [
          "Lead end-to-end development of interactive email campaigns and In-App Messages (IAMs) using Braze Liquid logic, improving personalisation and engagement across client marketing programmes.",
          "Architected and built full gamification features (scratch cards, spin-the-wheel mechanics) within Braze, including custom reward handling and dynamic audience targeting logic.",
          "Developed and maintained internal application features end-to-end using React.js and Node.js, deploying via AWS DynamoDB, App Runner, and Amplify for cloud-native, scalable delivery.",
        ],
      },
    ],
  },
  {
    company: "Telaverge Communications",
    companyUrl: "https://telavergecommunications.com/",
    location: "Bangalore, India",
    roles: [
      {
        title: "Senior Software Engineer",
        dateRange: "Jan 2024 – Aug 2024",
        bullets: [
          "Led front-end development for in-house and customer-facing platforms using React.js, Vue.js, Node.js, and MySQL within Linux-based environments.",
          "Integrated REST APIs and streamlined component styling workflows, contributing directly to architecture decisions for scalable full-stack applications delivered on schedule.",
        ],
      },
      {
        title: "Software Engineer",
        dateRange: "Apr 2021 – Dec 2023",
        bullets: [
          "Delivered full-stack features consistently on time while maintaining close communication with end users and cross-functional teams to ensure project success.",
          "Managed AWS/NGINX server deployments and partnered with DevOps to streamline Git workflows and Jenkins CI/CD pipelines, reducing manual release effort.",
          "Worked hands-on with AWS EC2, Aurora MySQL, S3, SES, and Secrets Manager to support and harden backend infrastructure.",
          "Built Node.js automation scripts for customer data migration, liaising directly with US-based clients to gather requirements and confirm delivery.",
        ],
      },
    ],
  },
];

const Experience = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const current = EXPERIENCES[currentIndex];
  const isFirst = currentIndex === 0;
  const isLast = currentIndex === EXPERIENCES.length - 1;

  return (
    <div className="experience-container">
      <div className="experience-content">
        <div className="experience-card">
          <div className="exp-header">
            <a
              href={current.companyUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="exp-company"
            >
              {current.company}
            </a>
            <span className="exp-location">{current.location}</span>
          </div>

          <div className="exp-scroll-area">
            {current.roles.map((role, i) => (
              <div className="exp-role" key={i}>
                <div className="exp-role-header">
                  <span className="exp-role-title">{role.title}</span>
                  <span className="exp-role-date">{role.dateRange}</span>
                </div>
                <div className="exp-role-divider" />
                <ul className="exp-bullets">
                  {role.bullets.map((bullet, bi) => (
                    <li key={bi}>{bullet}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="exp-footer">
            <button
              className="exp-nav-btn"
              onClick={() => setCurrentIndex((i) => i - 1)}
              disabled={isFirst}
            >
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="15 18 9 12 15 6" />
              </svg>
              Back
            </button>

            <div className="exp-dots">
              {EXPERIENCES.map((_, i) => (
                <span
                  key={i}
                  className={`exp-dot ${i === currentIndex ? "active" : ""}`}
                  onClick={() => setCurrentIndex(i)}
                />
              ))}
            </div>

            <button
              className="exp-nav-btn"
              onClick={() => setCurrentIndex((i) => i + 1)}
              disabled={isLast}
            >
              Next
              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Experience;
